import type { DataGridState } from '@sl/react-datafabric-components';

function removeEmpty(obj: unknown) {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== null && v !== undefined)
  );
}

export function convertStateToParams(gridState?: DataGridState): {
  [key: string]: any;
} {
  if (!gridState) return;

  const { rows, multiSort, filters, page, first, fields, searchDateField, ...otherParams } = gridState;

  const { queryString, fromDate, toDate, ...otherFilters } = filters || {};


  const params: { [key: string]: any } = {
    pageSize: rows,
    page,
    first,
    ...removeEmpty(otherParams),
  };

  if(fields) {
    params.fields = JSON.stringify(fields);
  }

  // Include searchDateField if present (for date filtering)
  if (searchDateField) {
    params.searchDateField = searchDateField;
  }

  // Include queryString if it exists (send even if empty to ensure cache invalidation)
  // Backend will ignore empty strings, but sending it ensures the query key changes
  if (queryString !== undefined && queryString !== null) {
    params.queryString = queryString;
  }

  if (otherFilters) {
    const updatedFind = removeEmpty(otherFilters)
    if (Object.keys(updatedFind).length) params.find = JSON.stringify(updatedFind);
  }

  // Include date filters - backend can handle one or both
  if (fromDate) {
    params.fromDate =
      fromDate instanceof Date ? fromDate.toISOString() : fromDate;
  }
  if (toDate) {
    params.toDate = toDate instanceof Date ? toDate.toISOString() : toDate;
  }

  if (multiSort && multiSort.length > 0) {
    params.multiSort = JSON.stringify(multiSort);
  }

  return params;
}